export const downloadFile = async (url, filename) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to fetch file");
    const blob = await response.blob();

    const link = document.createElement("a");
    const objectUrl = window.URL.createObjectURL(blob);
    link.href = objectUrl;
    link.download = filename;

    if (document.body) {
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(objectUrl);
      document.body.removeChild(link);
    } else {
      console.error("document.body is not available.");
    }
  } catch (error) {
    console.error("Error downloading the file:", error);
  }
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  // Check if the date is valid
  if (!isNaN(date.getTime())) {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }
  return "N/A"; // Return default "N/A" for invalid dates
};
export function formatDate1(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
}
export function formatDate2(dateString) {
  if (!dateString) {
    return "-";
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}
export const getLastDate = (array) => {
  if (array?.length === 0) return null;
  const lastObject = array[array.length - 1];
  return lastObject?.cdate?.$date || null;
};

export const convertTimestampToDate = (timestamp) => {
  if (!timestamp || isNaN(timestamp)) {
    return console.error("Invalid timestamp");
  }
  const date = new Date(timestamp);
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getUTCDate()).padStart(2, "0");
  const year = date.getUTCFullYear();
  return `${month}/${day}/${year}`;
};

export const formatAmount = (amount) => {
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatUSAmount = (amount) => {
  const formattedAmount = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  return formattedAmount.replace("$", "$ ");
};

export const formatAmountWithSuffix = (amount) => {
  if (amount >= 1000) {
    return `${(amount / 1000).toFixed(2)}M`;
  } else if (amount >= 1) {
    return `${amount.toFixed(2)}K`;
  } else {
    return amount.toFixed(2);
  }
};

// export const appendOtherFields = (originalArray, otherFieldValue) => {
//   if (otherFieldValue) {
//     const otherItems = otherFieldValue.split(",").map((item) => {
//       const trimmedItem = item.trim();
//       return {
//         value: trimmedItem === trimmedItem ? "" : trimmedItem, // This will always be true. So...
//         label: trimmedItem,
//       };
//     });

//     // Fix: set value to "" only when value === label
//     const fixedOtherItems = otherItems.map((item) => ({
//       value: item.value === item.label ? "" : item.value,
//       label: item.label,
//     }));

//     return [
//       ...originalArray.filter((item) => item.label !== "Other"),
//       ...fixedOtherItems,
//     ];
//   }
//   return originalArray;
// };
// ✅ Function to check if a value is a valid MongoDB ObjectId
const isValidMongoId = (id) => /^[a-f\d]{24}$/i.test(id);

export const appendOtherFields = (originalArray = [], otherFieldValue = "") => {
  // Step 1: Remove all previously added custom entries (value === "")
  let cleanedArray = originalArray.filter(item => item.value !== "");

  // Step 2: If there are no new custom values, just return the cleaned array
  if (!otherFieldValue.trim()) {
    return cleanedArray.map(item => ({
      ...item,
      value: isValidMongoId(item.value) ? item.value : "" // enforce strict condition
    }));
  }

  // Step 3: Convert comma-separated new values into array
  const newItems = otherFieldValue.split(",").map(item => {
    const trimmedItem = item.trim();
    return {
      value: "", // always empty for new custom entries
      label: trimmedItem
    };
  });

  // Step 4: Prevent case-insensitive duplicates
  const existingLabels = new Set(cleanedArray.map(item => item.label.toLowerCase()));

  const uniqueNewItems = newItems.filter(
    newItem => !existingLabels.has(newItem.label.toLowerCase())
  );

  // Step 5: Final strict validation for existing values
  const finalCleanedArray = cleanedArray.map(item => ({
    ...item,
    value: isValidMongoId(item.value) ? item.value : "" // strict check here too
  }));

  // Step 6: Merge database entries with new custom entries
  return [...finalCleanedArray, ...uniqueNewItems];
};



export function formatSearchDateTime(dateObject) {
  if (!dateObject || !dateObject.$date) {
    return "Invalid Date";
  }

  const date = new Date(dateObject.$date);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  // Format the date and time as per your requirement
  const formattedDate = `${date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  })} ${date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  })}`;

  return formattedDate;
}

let globalNavigate = null;
export const setGlobalNavigate = (navigate) => {
  globalNavigate = navigate;
};

export const getGlobalNavigate = () => globalNavigate;

export function capitalizeFirstLetter(str) {
  return str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
}

export const getExcelColumnWidth = (data) => {
  const headers = Object.keys(data[0]);
  const colWidths = headers?.map((header) => {
    const maxContentLength = data?.reduce((max, row) => {
      const cellContent = row[header] ? row[header].toString() : "";
      return Math.max(max, cellContent.length);
    }, header.length);
    return { wch: maxContentLength + 2 };
  });
  return colWidths;
};
